module.exports = __webpack_public_path__ + "media/images/payment/logo_visa-0322b78b6ec886c51592865c52fbbcec.gif";